import {
	alias,
	date,
	deserialize,
	identifier,
	object,
	serializable,
} from "serializr";
import { IJsonObject } from "../api";
import { User } from "../users";

interface IProps {
	id?: number | null;
	userId?: number | null;
	taskId?: number | null;
	user?: User | null;
	hours?: number;
	logDate?: Date;
	description?: string;
}

export class ProjectTaskTimelog {
	public static fromJson(json: IJsonObject): ProjectTaskTimelog {
		return deserialize(ProjectTaskTimelog, json);
	}

	public static fromJsonArray(json: IJsonObject[]): ProjectTaskTimelog[] {
		return json.map((task: IJsonObject) => this.fromJson(task));
	}

	@serializable(identifier())
	public id: number | null;

	@serializable(alias("user_id"))
	public userId: number | null;

	@serializable(alias("task_id"))
	public taskId: number | null;

	@serializable
	public hours: number;

	@serializable
	public description: string;

	@serializable(alias("date", date()))
	public logDate: Date;

	@serializable(object(User))
	public user: User | null;

	constructor({
		id = null,
		userId = null,
		taskId = null,
		user = null,
		hours = 0,
		logDate = new Date(),
		description = "",
	}: IProps = {}) {
		this.id = id;
		this.userId = userId;
		this.taskId = taskId;
		this.user = user;
		this.hours = hours;
		this.logDate = logDate;
		this.description = description;
	}
}
